import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { map, Subject, takeUntil } from 'rxjs';
import { type FoodItemOutflowModel } from 'src/app/models/food-item-outflow.model';
import { AyBService } from 'src/app/services/api/ayb.service';
import { NotificationService } from 'src/shared/notification.service';

@Component({
  selector: 'app-dialog-edit-outflow-observation',
  templateUrl: './dialog-edit-outflow-observation.component.html',
  styleUrls: ['./dialog-edit-outflow-observation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogEditOutflowObservationComponent
  implements OnInit, OnDestroy
{
  private _unsubscribeOnDestroy$: Subject<boolean> = new Subject<boolean>();
  isLoading = false;
  isSuccess = false;
  editedOutflow: FoodItemOutflowModel | null = null;
  outflowObservationForm;

  constructor(
    public dialogRef: MatDialogRef<DialogEditOutflowObservationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      egresoInsumo: FoodItemOutflowModel;
      prevObservation?: string;
    },
    public dialog: MatDialog,
    private fb: FormBuilder,
    private readonly alimentosService: AyBService,
    private readonly notificationService: NotificationService,
  ) {
    this.outflowObservationForm = this.fb.group({
      observation: new FormControl<string>(
        dialogData.prevObservation || '',
        Validators.required,
      ),
    });
  }

  ngOnInit(): void {}

  async updateObservation() {
    this.isLoading = true;
    const observation = this.outflowObservationForm.value.observation;
    if (!observation || observation.trim() === '') {
      this.notificationService.notifyError(
        'La observación no puede estar vacía.',
      );
      this.isLoading = false;
      this.isSuccess = false;
      this.editedOutflow = null;
      return;
    }
    this.alimentosService
      .mutationUpdateEgresoInsumoObservation({
        id: this.dialogData.egresoInsumo.id || '',
        observation,
      })
      .pipe(
        takeUntil(this._unsubscribeOnDestroy$),
        map((res) => res.updateEgresoInsumoObservation),
      )
      .subscribe({
        next: (updateEgresoInsumoObservation) => {
          if (!updateEgresoInsumoObservation) {
            this.notificationService.notifyError(
              'No se pudo actualizar la observación del egreso.',
            );
            this.isSuccess = false;
            this.editedOutflow = null;
            this.isLoading = false;
            return;
          }
          this.isSuccess = true;
          this.isLoading = false;
          this.editedOutflow = updateEgresoInsumoObservation;
          this.closeDialogWithData();
          this.notificationService.showSuccessAlert(
            'Se actualizó el servicio exitosamente.',
          );
        },
        error: (err: any) => {
          this.isLoading = false;
          this.isSuccess = false;
          this.editedOutflow = null;
          this.notificationService.notifyError(err.message);
        },
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeOnDestroy$.next(true);
  }

  closeDialogWithNoData() {
    this.dialogRef.close({
      editedOutflow: null,
    });
  }

  closeDialogWithData() {
    this.dialogRef.close({
      editedOutflow: this.editedOutflow,
    });
  }
}
